const DATE_ONLY_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
}

const DATE_TIME_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
}

const toValidDate = (value) => {
  if (value == null || value === '') return null
  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

/** Portal display date, e.g. Aug 7, 2026 */
export const formatDate = (value, fallback = '—') => {
  const date = toValidDate(value)
  if (!date) return fallback
  return date.toLocaleDateString('en-US', DATE_ONLY_OPTIONS)
}

/** Portal display date + time, e.g. Aug 7, 2026, 4:42 PM */
export const formatDateTime = (value, fallback = '—') => {
  const date = toValidDate(value)
  if (!date) return fallback
  return date.toLocaleString('en-US', DATE_TIME_OPTIONS)
}

/** Time portion only, matching the verify dialog timestamp field. */
export const formatTime = (value, fallback = '—') => {
  const date = toValidDate(value)
  if (!date) return fallback
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  })
}
